
import { defineAction } from "redux-define";
import { SUCCESS, RESET, TheApp } from "../../constants/stateConstants";

export const BROWSE_HISTORY = defineAction("BROWSE_HISTORY", [SUCCESS, RESET], TheApp);
